import { FormsStatus } from '@/types'
import Team from '@/models/Team'
import Inspector from '@/models/Inspector'
import { SpecificPoint } from '@/components/SeismicInsepctionForm/_PointsParticuliers.vue'

export type CampaignType = 'Robustesse' | 'Deresma ind.E' | 'Deresma Gaine'

export default class SeismicForm {
  site!: Array<string>
  campaign!: string
  type!: CampaignType
  numeroFiche!: string
  numeroNoteMethodologique!: string
  numeroSchemaMecanique!: string
  supportage!: number
  tenants!: string
  tenants2!: string
  aboutissants!: string
  aboutissants2!: string
  inspectors?: Array<Inspector>
  ligne1!: Ligne
  ligne2?: Ligne
  ligne3?: Ligne
  ligne4?: Ligne
  status!: FormsStatus
  syncStatus?: FormsStatus
  comment!: string
  analysis!: {conclusion: AnalysisConclusion}
  tts?: boolean // TTS or Confrontation
  formHint?: string
  specificData!: SpecificData
  isCat23nc!: boolean
  bat!: string
  updateDate?: Date

  constructor (campaign: string | Partial<SeismicForm>, campaignType: CampaignType, tts: boolean, matrix?: Array<Array<string>>, site?: Array<string>, team?: Team) {
    if (!(typeof campaign === 'string' || campaign instanceof String)) {
      Object.assign(this, JSON.parse(JSON.stringify(campaign)))
      console.log('FORM -- initialize from json object', this)
    }
    if (!matrix) {
      return
    }
    this.site = site || this.getSitesFromMatrix(matrix)
    this.campaign = (campaign as string)
    this.type = campaignType
    this.numeroNoteMethodologique = ''
    this.inspectors = team?.inspectors
    this.status = FormsStatus.todo
    this.comment = ''
    this.tts = tts

    if (this.type === 'Robustesse') {
      this.numeroFiche = matrix[1][0]
      this.numeroSchemaMecanique = matrix[14][3]
      this.supportage = parseFloat(matrix[12][27])
      this.tenants = matrix[15][3]
      this.tenants2 = matrix[15][11]
      this.aboutissants = matrix[15][16]
      this.aboutissants2 = matrix[15][24]
      this.formHint = matrix[12][1]
      // this.inspectors = team?.inspectors.map(inspector => [inspector.firstName, inspector.lastName])
      let calorifuge
      if (matrix[21][3] === 'OUI' || matrix[21][3] === 'O') {
        calorifuge = true
      } else if (matrix[21][3] === 'NON' || matrix[21][3] === 'N') {
        calorifuge = false
      }
      this.ligne1 = {
        numero: matrix[16][3],
        numeroIso: matrix[17][3],
        dn: matrix[18][3],
        ep: matrix[19][3], // TODO: vérifier que c'est bon maintenant
        inox: matrix[20][3],
        ac: matrix[20][6],

        materiaux: matrix[20][3],
        calorifuge: calorifuge,
        densite: matrix[22][3],
        calorifugeO: matrix[21][2].length > 0,
        calorifugeEpc: matrix[21][8],
        robinet: matrix[24][3],
        local: matrix[25][3],
        masse: matrix[26][3],
        temperature: matrix[28][3],
        pression: matrix[28][7]
      }

      calorifuge = undefined
      if (matrix[21][13] === 'OUI' || matrix[21][13] === 'O') {
        calorifuge = true
      } else if (matrix[21][13] === 'NON' || matrix[21][13] === 'N') {
        calorifuge = false
      }
      this.ligne2 = {
        numero: matrix[16][13],
        numeroIso: matrix[17][13],
        dn: matrix[18][13],
        ep: matrix[19][13],
        inox: matrix[20][13],
        ac: matrix[20][13],
        materiaux: matrix[20][13],
        calorifuge: calorifuge,
        densite: matrix[22][13],
        calorifugeO: matrix[21][13].length > 0,
        calorifugeEpc: matrix[21][16],
        robinet: matrix[24][12],
        local: matrix[25][12],
        masse: matrix[26][12],
        temperature: matrix[28][12],
        pression: matrix[28][15]
      }
      // FIXME: need to b set to the right cells
      calorifuge = undefined
      if (matrix[21][22] === 'OUI' || matrix[21][22] === 'O') {
        calorifuge = true
      } else if (matrix[21][22] === 'NON' || matrix[21][22] === 'N') {
        calorifuge = false
      }
      this.ligne3 = {
        numero: matrix[16][22],
        numeroIso: matrix[17][22],
        dn: matrix[18][22],
        ep: matrix[19][22],
        inox: matrix[20][22],
        ac: matrix[20][22],
        materiaux: matrix[20][22],
        calorifuge: calorifuge,
        densite: matrix[22][22],
        calorifugeO: matrix[21][22].length > 0,
        calorifugeEpc: matrix[21][25],
        robinet: matrix[24][21],
        local: matrix[25][21],
        masse: matrix[26][21],
        temperature: matrix[28][21],
        pression: matrix[28][25]
      }
      this.bat = matrix[36][1]

      this.specificData = {
        lvqe61: matrix[30][7],
        mDn1: matrix[30][11],
        lvqe62: matrix[30][20],
        mDn2: matrix[30][24],
        acceleration1: {
          h: matrix[31][4],
          levelH: matrix[31][10],
          v: matrix[31][18],
          levelV: matrix[31][24]
        },
        acceleration2: {
          h: matrix[32][4],
          levelH: matrix[32][10],
          v: matrix[32][18],
          levelV: matrix[32][24]
        },
        acceleration3: {
          h: matrix[33][4],
          levelH: matrix[33][10],
          v: matrix[33][18],
          levelV: matrix[33][24]
        },
        acceleration4: {
          h: matrix[34][4],
          levelH: matrix[34][10],
          v: matrix[34][18],
          levelV: matrix[34][24]
        },
        acceleration5: {
          h: matrix[35][4],
          levelH: matrix[35][10],
          v: matrix[35][18],
          levelV: matrix[35][24]
        }

      }
      // TODO: get data from checkbox or other?
      this.isCat23nc = !!(matrix[36][2] && true)
    } else if (this.type === "Deresma ind.E") {
      // on lit toujours le premier élément en entier même s'il y a plusieurs équipement, on fait juste attention au n° d'équipement
      this.numeroFiche = matrix[0][18]
      this.numeroSchemaMecanique = matrix[0][7]
      this.supportage = parseFloat(matrix[0][40])
      this.tenants = matrix[0][19]
      this.tenants2 = matrix[0][6]
      this.aboutissants = matrix[0][20]
      this.aboutissants2 = matrix[0][21]

      this.tts = false
      this.formHint = matrix[0][42]

      let calorifuge
      if (matrix[0][26].toLowerCase() === 'oui' || matrix[0][26].toLowerCase() === 'o') {
        calorifuge = true
      } else if (matrix[0][26].toLowerCase() === 'non' || matrix[0][26].toLowerCase() === 'n') {
        calorifuge = false
      }
      const ligne = {
        numero: matrix[0][3],
        numeroIso: matrix[0][8],
        dn: matrix[0][5],
        ep: matrix[0][23],
        inox: matrix[0][25],
        ac: '', // semble être inutile
        materiaux: matrix[0][25],
        calorifuge: calorifuge,
        densite: matrix[0][28],
        calorifugeO: false, // semble être inutile
        calorifugeEpc: matrix[0][27],
        robinet: matrix[0][12],
        local: matrix[0][6],
        masse: matrix[0][13],
        temperature: matrix[0][29],
        pression: matrix[0][30], // TODO prendre en compte les informations d'après pour la première page de la fiche
        reference: matrix[0][15], // correspond au robinet/masse/rin/classement/local
        classement: matrix[0][10],
        niveau: matrix[0][11]
      }
      if (parseFloat(matrix[0][17]) === 1) {
        this.ligne1 = ligne
      } else if (parseFloat(matrix[0][17]) === 2) {
        this.ligne2 = ligne
      } else if (parseFloat(matrix[0][17]) === 3) {
        this.ligne3 = ligne
      } else if (parseFloat(matrix[0][17]) === 4) {
        this.ligne4 = ligne
      }

      this.bat = matrix[0][41]

      this.specificData = {
        lvqe61: '',
        mDn1: '',
        lvqe62: '',
        mDn2: '',
        acceleration1: {
          h: matrix[0][32],
          levelH: matrix[0][33],
          v: matrix[0][36],
          levelV: matrix[0][37]
        },
        acceleration2: {
          h: matrix[0][34],
          levelH: matrix[0][35],
          v: matrix[0][38],
          levelV: matrix[0][39]
        }
      }

      if (matrix.length > 1) {
        for (let i = 1; i < matrix.length; i++) {
          let calorifuge
          if (matrix[i][26].toLowerCase() === 'oui' || matrix[i][26].toLowerCase() === 'o') {
            calorifuge = true
          } else if (matrix[i][26].toLowerCase() === 'non' || matrix[i][26].toLowerCase() === 'n') {
            calorifuge = false
          }
          const ligne = {
            numero: matrix[i][3],
            numeroIso: matrix[i][8],
            dn: matrix[i][5],
            ep: matrix[i][23],
            inox: matrix[i][25],
            ac: '', // semble être inutile
            materiaux: matrix[i][25],
            calorifuge: calorifuge,
            densite: matrix[i][28],
            calorifugeO: false, // semble être inutile
            calorifugeEpc: matrix[i][27],
            robinet: matrix[i][12],
            local: matrix[i][6],
            masse: matrix[i][13],
            temperature: matrix[i][29],
            pression: matrix[i][30],
            reference: matrix[i][15], // correspond au robinet/masse/rin/classement/local
            classement: matrix[i][10],
            niveau: matrix[i][11]
          }
          if (parseFloat(matrix[i][17]) === 1) {
            this.ligne1 = ligne
          } else if (parseFloat(matrix[i][17]) === 2) {
            this.ligne2 = ligne
          } else if (parseFloat(matrix[i][17]) === 3) {
            this.ligne3 = ligne
          } else if (parseFloat(matrix[i][17]) === 4) {
            this.ligne4 = ligne
          }
        }
      }
      // On initialise les lignes 2, 3 et 4 vides pour qu'elles puissent être remplies si nécessaire
      const ligneVide = {
        numero: '',
        numeroIso: '',
        dn: '',
        ep: '',
        inox: '',
        ac: '',
        materiaux: '',
        densite: '',
        calorifuge: undefined,
        calorifugeO: false,
        calorifugeEpc: '',
        robinet: '',
        local: '',
        masse: '',
        temperature: '',
        pression: '',
        reference: '',
        classement: '',
        niveau: ''
      }
      if (matrix.length === 1) {
        this.ligne2 = ligneVide
        this.ligne3 = ligneVide
        this.ligne4 = ligneVide
      } else if (matrix.length === 2) {
        this.ligne3 = ligneVide
        this.ligne4 = ligneVide
      } else if (matrix.length === 3) {
        this.ligne4 = ligneVide
      }
    }

    this.analysis = {
      conclusion: {
        inspectionDone: false,
        inspectionConclusion: InspectionConclusion.null,
        additionalInspectionConclusion: AdditionalInspectionConclusion.null,
        isPaidDuty: null,
        issueDescription: '',
        comment: '',
        picturesReference: ''
      }
    }
  }

  getSitesFromMatrix (matrix: Array<Array<string>>): Array<string> {
    const output = []

    if (matrix[4][3].length > 0) { output.push('BG-2') }
    if (matrix[4][4].length > 0) { output.push('BG-3') }
    if (matrix[4][5].length > 0) { output.push('BG-4') }
    if (matrix[4][6].length > 0) { output.push('BG-5') }
    if (matrix[5][2].length > 0) { output.push('FS-1') }
    if (matrix[5][3].length > 0) { output.push('FS-2') }

    if (matrix[8][2].length > 0) { output.push('CZ-1') }
    if (matrix[8][3].length > 0) { output.push('CZ-2') }
    if (matrix[9][2].length > 0) { output.push('CV-1') }
    if (matrix[9][3].length > 0) { output.push('CV-2') }

    if (matrix[4][9].length > 0) { output.push('TN-1') }
    if (matrix[4][10].length > 0) { output.push('TN-2') }
    if (matrix[4][11].length > 0) { output.push('TN-3') }
    if (matrix[4][12].length > 0) { output.push('TN-4') }
    if (matrix[5][9].length > 0) { output.push('DA-1') }
    if (matrix[5][10].length > 0) { output.push('DA-2') }
    if (matrix[5][11].length > 0) { output.push('DA-3') }
    if (matrix[5][12].length > 0) { output.push('DA-4') }
    if (matrix[6][9].length > 0) { output.push('GR-1') }
    if (matrix[6][10].length > 0) { output.push('GR-2') }
    if (matrix[6][11].length > 0) { output.push('GR-3') }
    if (matrix[6][12].length > 0) { output.push('GR-4') }
    if (matrix[6][13].length > 0) { output.push('GR-5') }
    if (matrix[6][14].length > 0) { output.push('GR-6') }
    if (matrix[7][9].length > 0) { output.push('BL-1') }
    if (matrix[7][10].length > 0) { output.push('BL-2') }
    if (matrix[7][11].length > 0) { output.push('BL-3') }
    if (matrix[7][12].length > 0) { output.push('BL-4') }
    if (matrix[8][9].length > 0) { output.push('SL-1') }
    if (matrix[8][10].length > 0) { output.push('SL-2') }
    if (matrix[9][9].length > 0) { output.push('CH-1') }
    if (matrix[9][10].length > 0) { output.push('CH-2') }
    if (matrix[9][11].length > 0) { output.push('CH-3') }
    if (matrix[9][12].length > 0) { output.push('CH-4') }
    if (matrix[10][9].length > 0) { output.push('CS-1') }
    if (matrix[10][10].length > 0) { output.push('CS-2') }
    if (matrix[10][11].length > 0) { output.push('CS-3') }
    if (matrix[10][12].length > 0) { output.push('CS-4') }

    if (matrix[4][17].length > 0) { output.push('BV-1') }
    if (matrix[4][18].length > 0) { output.push('BV-2') }
    if (matrix[5][17].length > 0) { output.push('CA-1') }
    if (matrix[5][18].length > 0) { output.push('CA-2') }
    if (matrix[5][19].length > 0) { output.push('CA-3') }
    if (matrix[5][20].length > 0) { output.push('CA-4') }
    if (matrix[6][17].length > 0) { output.push('GF-1') }
    if (matrix[6][18].length > 0) { output.push('GF-2') }
    if (matrix[7][17].length > 0) { output.push('NO-1') }
    if (matrix[7][18].length > 0) { output.push('NO-2') }
    if (matrix[8][17].length > 0) { output.push('PY-1') }
    if (matrix[8][18].length > 0) { output.push('PY-2') }

    if (matrix[4][23].length > 0) { output.push('FA-1') }
    if (matrix[4][24].length > 0) { output.push('FA-2') }
    if (matrix[5][23].length > 0) { output.push('PA-1') }
    if (matrix[5][24].length > 0) { output.push('PA-2') }
    if (matrix[5][25].length > 0) { output.push('PA-3') }
    if (matrix[5][26].length > 0) { output.push('PA-4') }
    if (matrix[6][23].length > 0) { output.push('SA-1') }
    if (matrix[6][24].length > 0) { output.push('SA-2') }

    return output
  }
}

export class RobustesseForm extends SeismicForm {
  analysis!: RAnalysis
  constructor (campaign: string | Partial<SeismicForm>, campaignType: CampaignType, tts: boolean, matrix?: Array<Array<string>>, site?: Array<string>, team?: Team) {
    super(campaign, campaignType, tts, matrix, site, team)
    if (!(typeof campaign === 'string' || campaign instanceof String)) {
      Object.assign(this, JSON.parse(JSON.stringify(campaign)))
      console.log('FORM -- initialize from json object', this)
    }
    if (!matrix) {
      return
    }
    this.analysis = {
      specificPoints: [],
      applicability: {
        pipeNominalDiameter: undefined,
        calculationJustification: undefined,
        lowPressureTemperature: undefined,
        accessibleHolder: undefined,
        remarkableElements: []
      },
      simpleTrunkAnalysis1: {
        noExcessiveCorrosion: undefined,
        noExcessiveDistortion: undefined,
        noWronglyBuiltStructure: undefined,
        remarkableElements: []
      },
      simpleTrunkAnalysis2: {
        notLinkedToFlexible: undefined,
        wellSupportedOnFlexibleLinks: undefined,
        noRiskOfDamageOnLinks: undefined,

        noLinkBetweenScrewedPipes: undefined,
        noRiskOfUnscrewOnCrankEffect: undefined,

        noMechanicalJointsOnFriction: undefined,
        seemOrHoldingDispositiveAvoidUnscrew: undefined,
        remarkableElements: [],
        irregularCriteriaUnderCNPE: undefined
      },
      simpleTrunkAnalysis3: {
        verticalHolderStepLowerThanAllowable: undefined,
        allowableStepValue: matrix[12][27],
        measuredStepValue: undefined,
        missingSupports: [],
        regularVerticalHolder: undefined,

        axialLockNearElbow: undefined,
        oneLockEvery3Supports: undefined,
        remarkableElements: [],
        postSeismicREXisApplied: undefined
      },
      simpleTrunkAnalysis4: {
        rightHolderFixing: undefined,
        actionForGC: undefined,
        rightExpansionPin: undefined,
        remarkableElements: [],
        postSeismicREXisApplied: undefined
      },
      sensibleTrunkAnalysis: {
        noTrunkWithBuildingThrough: undefined,
        noTrunkWithDDS: undefined,
        noTrunkWithEmbeddedMass: undefined,
        noOffsetMass: undefined,
        noType123Valve: undefined,
        GCCorrectFixing: undefined,
        remarkableElements: [],
        dutyPaidMaterial: undefined
      },
      conclusion: {
        inspectionDone: false,
        inspectionConclusion: InspectionConclusion.null,
        additionalInspectionConclusion: AdditionalInspectionConclusion.null,
        isPaidDuty: null,
        issueDescription: '',
        comment: '',
        picturesReference: ''
      }
    }
  }

  /**
   * This method look at the checked responses and check the matching conclusion if possible:
   * - every question is marked as SO => the local conclusion is set to SO if not yet filled
   * - every question is marked as YES => the local conclusion is set to YES if not yet filled
   * - at least one question is marked as NO => the local conclusion is set to NO if not yet filled
   */
  calculateConclusions ():void {
    // Simple trunk analysis 1
    const st1 = this.analysis!.simpleTrunkAnalysis1
    const st2 = this.analysis!.simpleTrunkAnalysis2
    const st3 = this.analysis!.simpleTrunkAnalysis3
    const st4 = this.analysis!.simpleTrunkAnalysis4
    console.log('CONCLUSIONS', this.analysis)

    if (st1.noExcessiveCorrosion && st1.noExcessiveDistortion && st1.noWronglyBuiltStructure &&
        st2.notLinkedToFlexible && st2.noLinkBetweenScrewedPipes && st2.noMechanicalJointsOnFriction && st2.irregularCriteriaUnderCNPE &&
        st3.verticalHolderStepLowerThanAllowable && st3.regularVerticalHolder &&
        st3.axialLockNearElbow && st3.oneLockEvery3Supports) {
      st3.postSeismicREXisApplied = true
    } else if (st1.noExcessiveCorrosion === null && st1.noExcessiveDistortion === null && st1.noWronglyBuiltStructure === null &&
        st2.notLinkedToFlexible === null && st2.noLinkBetweenScrewedPipes === null && st2.noMechanicalJointsOnFriction === null && st2.irregularCriteriaUnderCNPE === null &&
        st3.verticalHolderStepLowerThanAllowable && st3.regularVerticalHolder &&
        st3.axialLockNearElbow === null && st3.oneLockEvery3Supports === null) {
      st3.postSeismicREXisApplied = null
    }
  }
}

export class DeresmaForm extends SeismicForm {
  analysis!: DAnalysis

  constructor (campaign: string | Partial<SeismicForm>, campaignType: CampaignType, tts: boolean, matrix?: Array<Array<string>>, site?: Array<string>, team?: Team) {
    super(campaign, campaignType, tts, matrix, site, team)
    if (!matrix) {
      return
    }
    this.analysis = {
      specificPoints: [],
      methodApplicability: {
        pipeNominalDiameter: undefined,
        lowPressureTemperature: undefined,
        pipingClass: true,
        accessibleHolder: undefined,
        remarkableElements: []
      },
      rexApplicability: {
        enveloppSpectrum: undefined,
        ratioDiamThick: undefined,
        mechanicalCarac: undefined,
        highPressureTemperature: undefined,
        sensitiveConnections: undefined,
        remarkableElements: []
      },
      inspectionCriteria1: {
        excessiveDistortion: undefined,
        weldingFaults: undefined,
        wrongStructureModification: undefined,
        wrongBuildStructure: undefined,
        remarkableElements: []
      },
      inspectionCriteria1a: {
        visibleCorrosion: undefined,
        visibleCorrosionDegradation: undefined,
        remarkableElements: []
      },
      inspectionCriteria2: {
        verticalSupportDistance: undefined,
        nutDefect: undefined,
        efficientSupport: undefined,
        pipeWear: undefined,
        supportInterval: undefined,
        noExcessiveMass: undefined,
        materialFrictionPieces: undefined,
        otherBadConfig: undefined,
        remarkableElements: []
      },
      inspectionCriteria3: {
        connectedEquipmentAnchor: undefined,
        rigidPipeFlexEquipment: undefined,
        accommodatingPipe: undefined,
        notBadConfig: undefined,
        remarkableElements: []
      },
      inspectionCriteria4: {
        vulnerableSeal: undefined,
        remarkableElements: []
      },
      inspectionCriteria4a: {
        pipeSpecificEffort: undefined,
        otherBadConfig: undefined,
        remarkableElements: []
      },
      inspectionCriteria5: {
        offsetMassSupport: undefined,
        noTappingDefect: undefined,
        notBadConfig: undefined,
        remarkableElements: []
      },
      inspectionCriteria5a: {
        rigidSupport: undefined,
        notBadConfig: undefined,
        remarkableElements: []
      },
      inspectionCriteria6: {
        attackerJustified: undefined,
        noInteractionRisk: undefined,
        noObstacle: undefined,
        remarkableElements: []
      },
      seismicCapacity: {
        deresmaApplicability: undefined,
        horizontalInterval: undefined,
        verticalInterval: undefined,
        admissibleDds: undefined,
        allowableHStepValue: matrix[0][40],
        measuredHStepValue: undefined,
        allowableVStepValue: matrix[0][40],
        measuredVStepValue: undefined,
        remarkableElements: []
      },
      conclusion: {
        inspectionDone: false,
        inspectionConclusion: InspectionConclusion.null,
        additionalInspectionConclusion: AdditionalInspectionConclusion.null,
        isPaidDuty: null,
        issueDescription: '',
        comment: '',
        picturesReference: ''
      }
    }
  }
}

type Chooser = 'O' | 'N' | 'S.O.' | null;
type StrictChooser = 'O' | 'N' | null;

type MaterialGaine = {
  name: string;
  temp: string
}

export const MaterialsGaine: MaterialGaine[] = [
  {
    name: "Acier carbone laminé à chaud",
    temp: "204 °C (400 °F)"
  },
  {
    name: "Acier carbone laminé à froid",
    temp: "204 °C (400 °F)"
  },
  {
    name: "Acier galvanisé",
    temp: "204 °C (400 °F)"
  },
  {
    name: "Acier inoxydable",
    temp: "204 °C (400 °F)"
  },
  {
    name: "Aluminium",
    temp: "149 °C (300 °F)"
  }
]

export class DeresmaGaineForm extends SeismicForm {
  data!: {
    palier?: string;
    applicability?: string;
    se?: string;
    local?: string;
    site_tranche_se_local?: string;
    localisation?: string;
    fiche?: string;
    section_epaisseur?: {
      section: string;
      epaisseur: string;
    }[];
    geometrie?: string;
    materiau?: string;
    protection_incendie?: string;
    niveau_local?: string;
    niveau_sismique?: string;
    gamma_h1?: string;
    gamma_h2?: string;
    gamma_v1?: string;
    gamma_v2?: string;
    commentaire1?: string;
    registre?: string;
    description?: string;
    commentaire2?: string;
    campagne?: string;
  }

  matrix?: Array<string>

  analysis!: {
    specificPoints: Array<SpecificPoint>
    gaines: {
      includeInPerimeter: Chooser;
      material: number | null;
      liaison_support: Chooser;
      gaine_circulaire_poinconnement: Chooser;
      porte_a_faux_maintien: Chooser;
      liaison_troncons: Chooser;
      fixation_materiels: Chooser;
      support_materiels_lourds: Chooser;
      pas_points_rigides: Chooser;
      pas_corrosion_defaut: Chooser;
      liaison_non_rivete: Chooser;
      soufflets_flexibles: Chooser;
      particularites_satisfaisantes: Chooser;
      particularites_description: string | null;
      dispositions_constructives_adaptees: StrictChooser;
      remarkableElements: Array<string>;
    };

    registres: {
      liaison_correcte: Chooser;
      pas_deformation_gaine: Chooser;
      flex_lignes_connectees: Chooser;
      registre_comparable_base_sismique: Chooser;
      particularites_satisfaisantes: Chooser;
      particularites_description: string | null;
      dispositions_constructives_adaptees: StrictChooser;
      remarkableElements: Array<string>;
    };
    supports: {
        pas_attaches_friction: Chooser;
        pas_parties_manquantes: Chooser;
        pas_corrosion_visibles: Chooser;
        soudures_qualite: Chooser;
        pas_supports_rigides: Chooser;
        pas_tiges_courtes: Chooser;
        particularites_satisfaisantes: Chooser;
        particularites_description: string | null;
        dispositions_constructives_adaptees: StrictChooser;
        remarkableElements: Array<string>;
      };

    ancrage: {
        ancrages_visibles: Chooser;
        ancrages_traitables_analogie: Chooser;
        type_ancrage: 'Chevilles à expansion' | 'Tiges scellées' | 'Autres' | null;
        type_autres_description: string | null;
        diametre_mm: 8 | 10 | 12 | 14 | 16 | 18 | 20 | 22 | 24 | 30 | 36 | null;
        distance_bord_libre_suffisante: Chooser;
        distance_entre_ancrages_suffisante: Chooser;
        fissures_acceptables: Chooser;
        transmission_efforts_correcte: Chooser;
        particularites_satisfaisantes: Chooser;
        particularites_description: string | null;
        systeme_adapte: StrictChooser;
        remarkableElements: Array<string>;
      };

    interactions_sismiques: {
        pas_impact_elements_fragiles: Chooser;
        pas_effondrement_surplomb: Chooser;
        flex_lignes_connectees: Chooser;
        deplacements_differentiel_admissibles: Chooser;
        risque_interaction_ecarte: StrictChooser;
        remarkableElements: Array<string>;
      };

    capacite_sismique_gaines: {
      configuration_enveloppe: Chooser;
      fiche_configuration_enveloppe: string | null;
      capacite_superieure_demande: StrictChooser;
      pas_horizontal_mesuré: string | null;
      pas_vertical_mesuré: string | null;
      pas_horizontal_admissible: string | null;
      pas_vertical_admissible: string | null;
      remarkableElements: Array<string>;
    };

    capacite_sismique_supports: {
      configuration_enveloppe: Chooser;
      fiche_configuration_enveloppe?: string | null;
      capacite_superieure_demande: StrictChooser;
      remarkableElements: Array<string>;
    };

    conclusion: {
      inspectionDone: boolean | string | null
      inspectionConclusion : InspectionConclusion
      additionalInspectionConclusion: AdditionalInspectionConclusion
      isPaidDuty: boolean | string | null
      issueDescription: string
      comment: string
      picturesReference: string
    }
  }

  get analysisMaterial (): MaterialGaine | null {
    if (!this.analysis) return null
    if (!this.analysis.gaines) return null
    if (!this.analysis.gaines.material) return null
    return MaterialsGaine[this.analysis.gaines.material]
  }

  constructor (campaign: string | Partial<SeismicForm>, campaignType: CampaignType, tts: boolean, matrix?: Array<Array<string>>, site?: Array<string>, team?: Team) {
    super(campaign, campaignType, tts, matrix, site, team)
    this.matrix = undefined
    if (!matrix) {
      return
    }
    this.matrix = matrix[0]

    const section_epaisseur: {
      section: string;
      epaisseur: string;
    }[] = []
    const sections = this.matrix[7]?.split("\n") || []
    const epaisseurs = this.matrix[8]?.split("\n") || []

    for (let i = 0; i < sections.length; i++) {
      section_epaisseur.push({
        section: sections[i],
        epaisseur: epaisseurs[i]
      })
    }
    this.data = {
      palier: this.matrix[0],
      applicability: this.matrix[1],
      se: this.matrix[2],
      local: this.matrix[3],
      site_tranche_se_local: this.matrix[4],
      localisation: this.matrix[5],
      fiche: this.matrix[6],
      section_epaisseur: section_epaisseur,
      geometrie: this.matrix[9],
      materiau: this.matrix[10],
      protection_incendie: this.matrix[11],
      niveau_local: this.matrix[12],
      niveau_sismique: this.matrix[13],
      gamma_h1: this.matrix[14],
      gamma_h2: this.matrix[16],
      gamma_v1: this.matrix[18],
      gamma_v2: this.matrix[20],
      commentaire1: this.matrix[22],
      registre: this.matrix[23],
      description: this.matrix[24],
      commentaire2: this.matrix[25],
      campagne: this.matrix[26]
    }
    this.numeroFiche = this.data.fiche || ""
    this.analysis = {
      specificPoints: [],
      gaines: {
        includeInPerimeter: null,
        material: null,
        liaison_support: null,
        gaine_circulaire_poinconnement: null,
        porte_a_faux_maintien: null,
        liaison_troncons: null,
        fixation_materiels: null,
        support_materiels_lourds: null,
        pas_points_rigides: null,
        pas_corrosion_defaut: null,
        liaison_non_rivete: null,
        soufflets_flexibles: null,
        particularites_satisfaisantes: null,
        particularites_description: null,
        dispositions_constructives_adaptees: null,
        remarkableElements: []
      },

      registres: {
        liaison_correcte: null,
        pas_deformation_gaine: null,
        flex_lignes_connectees: null,
        registre_comparable_base_sismique: null,
        particularites_satisfaisantes: null,
        particularites_description: null,
        dispositions_constructives_adaptees: null,
        remarkableElements: []
      },

      supports: {
        pas_attaches_friction: null,
        pas_parties_manquantes: null,
        pas_corrosion_visibles: null,
        soudures_qualite: null,
        pas_supports_rigides: null,
        pas_tiges_courtes: null,
        particularites_satisfaisantes: null,
        particularites_description: null,
        dispositions_constructives_adaptees: null,
        remarkableElements: []
      },

      ancrage: {
        ancrages_visibles: null,
        ancrages_traitables_analogie: null,
        type_ancrage: null,
        type_autres_description: null,
        diametre_mm: null,
        distance_bord_libre_suffisante: null,
        distance_entre_ancrages_suffisante: null,
        fissures_acceptables: null,
        transmission_efforts_correcte: null,
        particularites_satisfaisantes: null,
        particularites_description: null,
        systeme_adapte: null,
        remarkableElements: []
      },

      interactions_sismiques: {
        pas_impact_elements_fragiles: null,
        pas_effondrement_surplomb: null,
        flex_lignes_connectees: null,
        deplacements_differentiel_admissibles: null,
        risque_interaction_ecarte: null,
        remarkableElements: []
      },

      capacite_sismique_gaines: {
        configuration_enveloppe: null,
        fiche_configuration_enveloppe: null,
        capacite_superieure_demande: null,
        pas_horizontal_mesuré: null,
        pas_vertical_mesuré: null,
        pas_horizontal_admissible: null,
        pas_vertical_admissible: null,
        remarkableElements: []
      },

      capacite_sismique_supports: {
        configuration_enveloppe: null,
        fiche_configuration_enveloppe: null,
        capacite_superieure_demande: null,
        remarkableElements: []
      },

      conclusion: {
        inspectionDone: null,
        inspectionConclusion: InspectionConclusion.null,
        additionalInspectionConclusion: AdditionalInspectionConclusion.null,
        isPaidDuty: null,
        issueDescription: '',
        comment: '',
        picturesReference: ''
      }
    }
  }
}

export class Ligne {
  numero: string | undefined
  numeroIso: string | undefined
  dn: string | undefined
  ep: string | undefined
  inox: string | undefined
  ac: string | undefined
  materiaux: string | undefined
  calorifuge: boolean | undefined
  densite: string | undefined
  calorifugeO: boolean | undefined
  calorifugeEpc: string | undefined
  robinet: string | undefined
  local: string | undefined
  masse: string | undefined
  temperature: string | undefined
  pression: string | undefined
  reference?: string | undefined
  classement?: string | undefined
  niveau?: string | undefined
}

export type AnalysisConclusion = {
  inspectionDone: boolean | string | null
  inspectionConclusion : InspectionConclusion
  additionalInspectionConclusion: AdditionalInspectionConclusion
  isPaidDuty: boolean | string | null
  issueDescription: string
  comment: string
  picturesReference: string
}

export type RAnalysis = {
  specificPoints: Array<SpecificPoint>
  applicability: {
    pipeNominalDiameter: boolean | null | undefined
    calculationJustification: boolean | null | undefined
    lowPressureTemperature: boolean | null | undefined
    accessibleHolder: boolean | null | undefined
    remarkableElements: Array<string>
  }
  simpleTrunkAnalysis1: {
    noExcessiveCorrosion: boolean | null | undefined
    noExcessiveDistortion : boolean | null | undefined
    noWronglyBuiltStructure: boolean | null | undefined
    remarkableElements: Array<string>
  }
  simpleTrunkAnalysis2: {
    notLinkedToFlexible: boolean | null | undefined
    wellSupportedOnFlexibleLinks: boolean | null | undefined
    noRiskOfDamageOnLinks: boolean | null | undefined

    noLinkBetweenScrewedPipes: boolean | null | undefined
    noRiskOfUnscrewOnCrankEffect: boolean | null | undefined

    noMechanicalJointsOnFriction: boolean | null | undefined
    seemOrHoldingDispositiveAvoidUnscrew: boolean | null | undefined
    remarkableElements: Array<string>
    irregularCriteriaUnderCNPE: boolean | null | undefined
  }
  simpleTrunkAnalysis3: {
    verticalHolderStepLowerThanAllowable: boolean | null | undefined
    allowableStepValue: string | null | undefined
    measuredStepValue: string | null | undefined
    regularVerticalHolder: boolean | null | undefined
    missingSupports: Array<string>

    axialLockNearElbow: boolean | null | undefined
    oneLockEvery3Supports: boolean | null | undefined
    remarkableElements: Array<string>
    postSeismicREXisApplied: boolean | null | undefined
  }
  simpleTrunkAnalysis4: {
    rightHolderFixing: boolean | null | undefined
    actionForGC: boolean | null | undefined
    rightExpansionPin: boolean | null | undefined
    remarkableElements: Array<string>
    postSeismicREXisApplied: boolean | null | undefined
  }
  sensibleTrunkAnalysis: {
    noTrunkWithBuildingThrough: boolean | null | undefined
    noTrunkWithDDS: boolean | null | undefined
    noTrunkWithEmbeddedMass: boolean | null | undefined
    noOffsetMass: boolean | null | undefined
    noType123Valve: boolean | null | undefined
    GCCorrectFixing: boolean | null | undefined
    remarkableElements: Array<string>
    dutyPaidMaterial: boolean | null | undefined
  },
  conclusion: {
    inspectionDone: boolean | string | null
    inspectionConclusion : InspectionConclusion
    additionalInspectionConclusion: AdditionalInspectionConclusion
    isPaidDuty: boolean | string | null
    issueDescription: string
    comment: string
    picturesReference: string
  }
}

export type DAnalysis = {
  specificPoints: Array<SpecificPoint>
  methodApplicability: {
    pipeNominalDiameter: boolean | null | undefined
    lowPressureTemperature: boolean | null | undefined
    pipingClass: boolean | null | undefined
    accessibleHolder: boolean | null | undefined
    remarkableElements: Array<string>
  }
  rexApplicability: {
    enveloppSpectrum: boolean | null | undefined
    ratioDiamThick: boolean | null | undefined
    mechanicalCarac: boolean | null | undefined
    highPressureTemperature: boolean | null | undefined
    sensitiveConnections: boolean | null | undefined
    remarkableElements: Array<string>
  }
  inspectionCriteria1: {
    excessiveDistortion: boolean | null | undefined
    weldingFaults: boolean | null | undefined
    wrongStructureModification: boolean | null | undefined
    wrongBuildStructure: boolean | null | undefined
    remarkableElements: Array<string>
  }
  inspectionCriteria1a: {
    visibleCorrosion: boolean | null | undefined
    visibleCorrosionDegradation: boolean | null | undefined
    remarkableElements: Array<string>
  }
  inspectionCriteria2: {
    verticalSupportDistance: boolean | null | undefined
    nutDefect: boolean | null | undefined
    efficientSupport: boolean | null | undefined
    pipeWear: boolean | null | undefined
    supportInterval: boolean | null | undefined
    noExcessiveMass: boolean | null | undefined
    materialFrictionPieces: boolean | null | undefined
    otherBadConfig: boolean | null | undefined
    remarkableElements: Array<string>
  }
  inspectionCriteria3: {
    connectedEquipmentAnchor: boolean | null | undefined
    rigidPipeFlexEquipment: string | null | undefined
    accommodatingPipe: string | null | undefined
    notBadConfig: boolean | null | undefined
    remarkableElements: Array<string>
  }
  inspectionCriteria4: {
    vulnerableSeal: boolean | null | undefined
    remarkableElements: Array<string>
  }
  inspectionCriteria4a: {
    pipeSpecificEffort: boolean | null | undefined
    otherBadConfig: boolean | null | undefined
    remarkableElements: Array<string>
  }
  inspectionCriteria5: {
    offsetMassSupport: boolean | null | undefined
    noTappingDefect: boolean | null | undefined
    notBadConfig: boolean | null | undefined
    remarkableElements: Array<string>
  }
  inspectionCriteria5a: {
    rigidSupport: boolean | null | undefined
    notBadConfig: boolean | null | undefined
    remarkableElements: Array<string>
  }
  inspectionCriteria6: {
    attackerJustified: boolean | null | undefined
    noInteractionRisk: boolean | null | undefined
    noObstacle: boolean | null | undefined
    remarkableElements: Array<string>
  }
  seismicCapacity: {
    deresmaApplicability: boolean | null | undefined
    horizontalInterval: boolean | null | undefined
    verticalInterval: boolean | null | undefined
    admissibleDds: boolean | null | undefined
    allowableHStepValue: string | null | undefined
    measuredHStepValue: string | null | undefined
    allowableVStepValue: string | null | undefined
    measuredVStepValue: string | null | undefined
    remarkableElements: Array<string>
  }
  conclusion: {
    inspectionDone: boolean | string | null
    inspectionConclusion : InspectionConclusion
    additionalInspectionConclusion: AdditionalInspectionConclusion
    isPaidDuty: boolean | string | null
    issueDescription: string
    comment: string
    picturesReference: string
  }

}

export enum InspectionConclusion {
  null,
  'paid-duty-no-suspicion'= 'Dédouanée suite à l\'inspection sans réserve',
  'paid-duty-suspicion' = 'Dédouanée suite à l\'inspection sous réserve d\'une AM',
  'additional-inspection-required' = 'Complément d\'étude nécessaire',
  'not-paid-duty-requires-modif' = 'Non dédouanée suite à l\'inspection, requiert une modification',
  'not-paid-duty-impossible-analysis' = 'Non dédouanée suite à l\'impossibilité de mener l\'inspection',
  'not-pair-duty' = 'Non dédouanée suite à l\'impossibilité de mener l\'inspection',
}
export enum AdditionalInspectionConclusion {
  null,
  'pair-duty-no-suspicion' = "Dédouané suite à l'inspection sans réserve",
  'pair-duty-suspicion' = "Dédouané suite à l'inspection sous réserve (indiquez)",
}

export type SpecificData = {
  lvqe61: string
  mDn1: string
  lvqe62: string
  mDn2: string
  acceleration1: {
    h: string
    levelH: string
    v: string
    levelV: string
  }
  acceleration2: {
    h: string
    levelH: string
    v: string
    levelV: string
  }
  acceleration3?: {
    h: string
    levelH: string
    v: string
    levelV: string
  }
  acceleration4?: {
    h: string
    levelH: string
    v: string
    levelV: string
  }
  acceleration5?: {
    h: string
    levelH: string
    v: string
    levelV: string
  }
}
